import React from 'react';

export default function Blog() {
  return (
    <main className="section-container py-16">
      <h2 className="text-3xl font-semibold text-brand">Blog</h2>
      <p className="mt-4 text-neutral/70">
        The original site links to an external Blogspot. You can host articles here or redirect.
      </p>
      <p className="mt-4">
        <a
          className="text-accent hover:text-accent/80"
          href="https://drpriyabhavechittawar1.blogspot.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit the external blog
        </a>
      </p>
    </main>
  );
}
